<ng-container *ngIf="formRef?.control as formRefControl">
  <form [formGroup]="formRefControl" class="cmn-forms">
    <div class="formContainer ">
      <div class="formContainer__formSection ">
        <h1 class="formSection__header">Business Information</h1>
        <div class="formSection__row">
          <div class="formSection__input row--fullWidthInput">
            <mat-radio-group formControlName="isIndividual">
              <mat-radio-button [value]="true">Individual</mat-radio-button>
              <mat-radio-button [value]="false">Company</mat-radio-button>
            </mat-radio-group>
            <!-- <mat-error>{{ page.controls.isTPQPApprovalRequired?.errors | formError }}</mat-error>
            <mat-icon *ngIf="!page.controls.isTPQPApprovalRequired?.errors" class="validCheck">check</mat-icon> -->
          </div>
        </div>
        <div *ngIf="!!formRefControl.controls.isIndividual?.value; else company" class="formSection__row row--twoInputs">
          <div class="formSection__input">
            <h2 class="input__title">PGO <span class="requiredIndicator">*</span></h2>
            <mat-form-field floatLabel="never">
              <input placeholder="PGO #" matInput type="text" formControlName="pgoNumber" />
              <mat-error>{{ $any(formRefControl).controls.pgoNumber?.errors | formError }}</mat-error>
              <mat-icon
                *ngIf="$any(formRefControl).controls.pgoNumber?.touched && !$any(formRefControl).controls.pgoNumber?.errors"
                class="validCheck"
                >check</mat-icon
              >
            </mat-form-field>
          </div>
        </div>
        <ng-template #company>
          <div class="formSection__row row--twoInputs">
            <div class="formSection__input">
              <h2 class="input__title">Company Name <span class="requiredIndicator">*</span></h2>
              <mat-form-field floatLabel="never">
                <input placeholder="Company Name" matInput type="text" formControlName="name" />
                <mat-error>{{ $any(formRefControl).controls.name?.errors | formError }}</mat-error>
                <mat-icon
                  *ngIf="$any(formRefControl).controls.name?.touched && !$any(formRefControl).controls.name?.errors"
                  class="validCheck"
                  >check</mat-icon
                >
              </mat-form-field>
            </div>
          </div>
        </ng-template>
        <div class="formSection__row ">
          <div class="formSection__input row--fullWidthInput">
            <widget-geo-code-address-autocomplete
              [isRequired]="true"
              (outputAddressDetailsEvent)="outputAddressDetailsEvent($event)"
              [addressSearchFormControl]="address.get('line1')"
            >
            </widget-geo-code-address-autocomplete>
            <!-- <mat-error>{{ address.controls.line1?.errors | formError }}</mat-error> -->
            <mat-icon *ngIf="address.controls.line1?.touched && !address.controls.line1?.errors" class="validCheck">check</mat-icon>
          </div>
        </div>
        <div class="formSection__row row--twoInputs">
          <div class="formSection__input" [formGroup]="address">
            <h2 class="input__title">Province<span class="requiredIndicator">*</span></h2>
            <mat-form-field floatLabel="never">
              <mat-select [required]="true" formControlName="provinceUniqueId">
                <mat-option>Select State/Province</mat-option>
                <mat-option [value]="province.uniqueId" *ngFor="let province of countryStoreService.provinces">
                  {{ province.name }}
                </mat-option>
              </mat-select>
              <mat-error>{{ address.controls.provinceUniqueId?.errors | formError }}</mat-error>
              <mat-icon *ngIf="address.controls.provinceUniqueId?.touched && !address.controls.provinceUniqueId?.errors" class="validCheck"
                >check</mat-icon
              >
            </mat-form-field>
          </div>
          <div class="formSection__input">
            <h2 class="input__title">Municipality</h2>
            <mat-form-field floatLabel="never">
              <input placeholder="" matInput type="text" formControlName="municipalityName" />
              <mat-error>{{ $any(formRefControl).controls.municipalityName?.errors | formError }}</mat-error>
              <mat-icon *ngIf="!$any(formRefControl).controls.municipalityName?.errors" class="validCheck">check</mat-icon>
            </mat-form-field>
          </div>
        </div>
        <div class="formSection__row row--twoInputs" [formGroup]="address">
          <div class="formSection__input ">
            <h2 class="input__title">City<span class="requiredIndicator">*</span></h2>
            <mat-form-field floatLabel="never">
              <input placeholder="" matInput type="text" formControlName="city" />
              <mat-error>{{ address.controls.city?.errors | formError }}</mat-error>
              <mat-icon *ngIf="address.controls.city?.touched && !address.controls.city?.errors" class="validCheck">check</mat-icon>
            </mat-form-field>
          </div>
          <div class="formSection__input">
            <h2 class="input__title">Postal Code <span class="requiredIndicator">*</span></h2>
            <mat-form-field floatLabel="never">
              <input placeholder="Postal Code" matInput type="text" formControlName="postalCode" />
              <mat-error>{{ address.controls.postalCode?.errors | formError }}</mat-error>
              <mat-icon *ngIf="address.controls.postalCode?.touched && !address.controls.postalCode?.errors" class="validCheck"
                >check</mat-icon
              >
            </mat-form-field>
          </div>
        </div>
        <div class="formSection__row extension--row">
          <div class="formSection__input">
            <h2 class="input__title">Company Phone <span class="requiredIndicator">*</span></h2>
            <mat-form-field floatLabel="never">
              <input placeholder="(000) 000 - 0000" matInput type="text" formControlName="phoneNumber" mask="(000) 000 - 0000" />
              <mat-error>{{ $any(formRefControl).controls.phoneNumber?.errors | formError }}</mat-error>
              <mat-icon
                *ngIf="$any(formRefControl).controls.phoneNumber?.touched && !$any(formRefControl).controls.phoneNumber?.errors"
                class="validCheck"
                >check</mat-icon
              >
            </mat-form-field>
          </div>
          <div class="formSection__input extension">
            <h2 class="input__title">Extension</h2>
            <mat-form-field floatLabel="never">
              <input placeholder="-" matInput type="text" formControlName="extension" />
              <mat-error>{{ $any(formRefControl).controls.extension?.errors | formError }}</mat-error>
              <!-- <mat-icon *ngIf="!$any(formRefControl).controls.extension?.errors" class="validCheck">check</mat-icon> -->
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-container>
